import React from 'react';

import SourceIcon from '@mui/icons-material/Source';
import { Box, Typography, Stack, Paper, IconButton } from '@mui/material';

import { Button } from 'shared';
import { Typewriter } from '../TypeWriter';
import { formatTransaction, formatInventory } from 'components/Inventory/utils/aiMatchingHelpers';

const CurrentMatchCard = ({
    currentCardIndex,
    data,
    renderingStage,
    advanceRenderingStage,
    handleEmailSourceClick,
    skipMatch,
    handleMatchClick,
    classes,
    currentSection,
    excludeLoading,
    handleExcludeClick,
    doNotShowAgainLoading,
    handleDoNotShowAgainClick,
}) => {
    if (
        currentSection !== 'matches' ||
        currentCardIndex === -1 ||
        currentCardIndex >= data.matches?.length
    )
        return null;

    const cardData = data.matches[currentCardIndex];

    const transactionObj = cardData.transaction || {
        id: cardData.transaction_id,
        amount: cardData.amount,
        date: cardData.date,
        description: cardData.description,
        vendor: cardData.description,
        card_last4: cardData.card_last4,
    };
    const transactionStr = formatTransaction(transactionObj);

    const inventoryStr = formatInventory(cardData.matched_inventory);

    return (
        <Paper key={`current-match-${currentCardIndex}`} elevation={3} sx={classes.matchCard}>
            <Box>
                <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                    Transaction
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                    {renderingStage >= 1 && (
                        <Typewriter
                            items={[transactionStr]}
                            renderItem={(text) => text}
                            delay={1000}
                            animate={true}
                            onComplete={
                                renderingStage === 1 ? () => advanceRenderingStage() : undefined
                            }
                        />
                    )}
                </Typography>

                {renderingStage >= 2 && (
                    <>
                        <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
                            Inventory
                        </Typography>
                        <Box display="flex" alignItems="center" gap={1} mb={2}>
                            <Typography variant="body1" sx={{ flexGrow: 1 }}>
                                <Typewriter
                                    items={[inventoryStr]}
                                    renderItem={(text) => text}
                                    delay={1000}
                                    animate={true}
                                    onComplete={
                                        renderingStage === 2
                                            ? () => advanceRenderingStage()
                                            : undefined
                                    }
                                />
                            </Typography>
                            {/* <IconButton
                                onClick={() => handleEmailSourceClick(cardData)}
                                sx={{ padding: 0 }}
                            >
                                <SourceIcon fontSize="small" />
                            </IconButton> */}
                        </Box>
                    </>
                )}

                {renderingStage === 3 && (
                    <Box sx={{ mt: 2 }}>
                        <Typewriter
                            items={[cardData.reasoning]}
                            renderItem={(text) => (
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontStyle: 'italic',
                                        color: '#666',
                                    }}
                                >
                                    {text}
                                </Typography>
                            )}
                            delay={1000}
                            animate={true}
                            onComplete={() => advanceRenderingStage()}
                        />
                    </Box>
                )}
                {renderingStage > 3 && (
                    <Typography
                        variant="body2"
                        sx={{
                            fontStyle: 'italic',
                            color: '#666',
                            mt: 2,
                        }}
                    >
                        {cardData.reasoning}
                    </Typography>
                )}

                {renderingStage >= 3 && (
                    <Stack
                        direction="row"
                        spacing={2}
                        justifyContent="space-between"
                        mt={3}
                        alignItems="center"
                        width="100%"
                    >
                        <Box>
                            <Button
                                sx={classes.cancelButton}
                                text="Don't Show Again"
                                loading={doNotShowAgainLoading}
                                onClick={() => {
                                    handleDoNotShowAgainClick(cardData, 'matchCard');
                                }}
                            />
                        </Box>

                        <Box display="flex" gap={2}>
                            <Button
                                sx={classes.cancelButton}
                                text="Exclude"
                                loading={excludeLoading}
                                onClick={() => {
                                    handleExcludeClick(cardData, 'matchCard');
                                }}
                            />

                            <Button
                                text="Skip"
                                sx={classes.cancelButton}
                                onClick={() => {
                                    skipMatch(cardData, 'matchCard');
                                }}
                            />

                            <Button
                                text="Match"
                                variant="contained"
                                onClick={() => handleMatchClick({}, cardData, 'matchCard')}
                            />
                        </Box>
                    </Stack>
                )}
            </Box>
        </Paper>
    );
};

export default CurrentMatchCard;
